import styled from 'styled-components/macro';
export const HolidayCheckoutWrapper = styled.div`
  width: 100%;
  .boxLeft {
  }
`;
